export default __webpack_public_path__ + "static/media/BU-Tetra(1).51d4f461.xlsx";